import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-lg font-semibold text-background-50 mb-4">
              欧美专区
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              精选欧美内容一站汇聚，涵盖欧美文化、时尚、品牌、音乐、影视与生活方式。您的欧美资讯权威目的地。
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="/about#contact"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                >
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4">
              关注我们
            </h4>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                aria-label="小红书"
                rel="nofollow"
              >
                <i className="ri-reddit-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; {currentYear} 欧美专区 OumeiZone. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}